module.exports = __webpack_public_path__ + "static/media/notFound.63681f78.svg";